













































































































































import Vue from 'vue';
import AgregarPagos from '@/components/pagos/AgregarPagos.vue';
import EgresoFormato from '@/components/egreso/EgresoFormato.vue';
// import {API, getDesserts} from '@/api';

export default Vue.extend({
  components: { AgregarPagos, EgresoFormato },
  data: () => ({
    headers: [
      { text: 'Proveedor',      value: 'proveedor.name' },
      { text: 'Fecha Emision',  value: 'fechaDeEmision' },
      { text: 'Monto cobro',    value: 'monto' },
      { text: 'Metodo Pago',    value: 'metodoDePago' },
      { text: 'Estatus',        value: 'estatusPago.nombre'},
      { text: 'Fecha Pago',     value: 'fechaPago' },
      { text: 'Editar',         value: 'edit' },
    ],
    precision: 2,
    total: 0,
    cobros: [],
    loading: true,
    options: {itemsPerPage: 100},
    saldo: {},
    menuDate: false,
    menuDatePP: false,
    datePP: '',
    date: '',
    formatoFecha: 'DD/MM/YYYY',
    disabled: false,

    editPayDialog: false,
    payItem: {},
    estatusPago: [],
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
  },
  methods: {
    computedDateFormattedPP(datePP) {
      console.debug('computedDateFormattedPP: ', datePP);
      return this.$moment(datePP).format(this.formatoFecha);
    },
    openEditDialog(item) {
      this.payItem = item;
      this.editPayDialog = true;
      console.debug('ItemToEdit: ', this.payItem);
    },
    // returilizar al crear el dialog
    async modifyPayment() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      console.debug('Payment: ', this.payItem);
      const response = await this.$store.dispatch('updateItem', {admin, condo, payItem: this.payItem});
      console.debug('modifyPayment: ', response);
      this.editPayDialog = false;
    },
    async actualizarSaldo() {
      try {
        this.saldo = {saldo: 0, egreso: 0};
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        console.log('prueba antes: ');
        const result = await this.$store.dispatch('postSaldoCondominio', {admin, condo, fecha: this.date});
        console.log('Prueba Saldo', result);
        this.saldo = result.data;
        let egreso = 0;
        this.cobros.forEach((x) => {
          egreso = egreso + x.monto;
        });
        this.saldo.egreso = egreso;
        console.log('egresos: ', egreso);
        this.disabled = true;
      } catch (e) {
        console.log('Error al obtener saldo');
        this.$toast.error('El saldo es igual a 0');
        this.disabled = false;
      }
    },
    async loadData() {
      try {
        this.date = this.$moment().format();
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getPagosList', {admin, condo, options: this.options});
        this.total = result.totalElements;
        this.cobros = result.data.content;
        console.debug('COBRO_LIST: %o', this.cobros);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
      this.listEstatusPago();
    },
    async listEstatusPago() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const response = await this.$store.dispatch('getListEP', {admin, condo});
      this.estatusPago = response.data;
      console.debug('listEstatusPago: ', response);
    },
    async addEstatusPagos() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const response = this.$store.dispatch('addEP', {admin, condo});
      console.debug('addEstatusPagos: ', response);
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    fecha(item) {
      console.debug('Fecha', item);
      const fecha = this.$moment(item).format('DD/MM/YYYY');
      return fecha;
    },
  },
  watch: {
    openDialog() {
      console.log('openDialog()');
    },
  },
});
